var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.75 28.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u05E2\\u05DC\\u05D9\\u05E0\\u05D5",
    "data-name": "\\u05E2\\u05DC\\u05D9\\u05E0\\u05D5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.54,0v28.2H0V0h27.54ZM18.33,20.07v-11.94h-9.12v11.94h9.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.09,0h9.21v15.51h-9.21V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.78,8.13h-12.83V0h26.18v8.13h-4.14v20.07h-9.21V8.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.99,0v28.2h-27.87v-8.13h4.89V0h9.21v20.07h4.56V0h9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.54,0h9.21v15.51h-9.21V0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpi);
export default __webpack_public_path__ + "static/media/יעדיםmdpi.7f748caa3daa7af262a74d858bdf13f0.svg";
export { ForwardRef as ReactComponent };